import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_ =
  "/merchflows/:merchflowId/flow-update/:storePogTriggerId";

export const RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_Export_ =
  "/merchflows/:merchflowId/flow-update/:storePogTriggerId/export";

export type ParamsGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_ = ExtractRouteParams<
  typeof RouteGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_
>;

export type FlowUpdateStorePogIdEntry = {
  previousStorePogId: number | null;
  updatedStorePogId: number | null;
};

export type QueryGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_ = {
  page?: number;
  pageSize?: number;
};

export type ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_ = {
  success_result_count: number;
  partial_result_count: number;
  fail_result_count: number;
  in_progress_count: number;
  total_stores: number;
  type: "STORE_PROP" | "FLOW_UPDATE" | "COPY_TO_STORES";
  error_details?: object[];
  storePogIds?: Record<string, FlowUpdateStorePogIdEntry>;
  details: {
    storeCode: string;
    changeType: "INSERT" | "SWAP" | "DELETE" | "FACINGS_INCREASED" | "FACINGS_DECREASED";
    productCode: string;
    swapOutProductCode?: string;
    swapInProductCode?: string;
    oldFacings?: number;
    newFacings?: number;
    errorMessage?: string | null;
    status: string | "SUCCESS";
    placementAttempts?: {
      locationId: string;
      status: string;
      errorMessage?: string | null;
    }[];
  }[];
};

export type ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_Error = {
  message: string;
  errors: string[];
};

export type FlowUpdateStorePogTriggerError =
  ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_Error;

export type FlowUpdateStorePogTriggerResponse =
  ResponseGetMerchflows_merchflowId_FlowUpdate_storePogTriggerId_ | FlowUpdateStorePogTriggerError;
